export class AccessStatus{
  public Name: string;
  public Description: string;
  public Code: string;
}

export class AccessStatusHelper{
  public static statusCodeToEnum(s: string): number{
    let si = parseInt(s);
    //return AccessStatusEnum[si];
    return si;
  }
}

export enum AccessStatusEnum {
  Undefined = 0,
  Active = 1,
  Suspended = 2,
  Blocked = 3,
  Trial = 4,
  Inactive = 5
}



// WEBPACK FOOTER //
// ./src/infrastructure/AccessStatus.ts